import styled, { css } from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Props {
  color?: string;
}

interface ImageProps {
  isDisplay?: boolean;
}

interface MultimediaProps {
  height?: string;
}

interface ButtonProps {
  isDisabled?: boolean;
}

export const Multimedia = styled.div`
  max-width: 286px;
  height: 152px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${COLORS.GRAY};
  overflow: hidden;
  position: relative;
  background: #fff;

  @media (min-width: ${SIZE.TABLET_BREAK}) {
    ${(props: MultimediaProps) => props.height && css`
      height: ${props.height};
    `}
  }
`;

export const Uploader = styled.label`
  overflow: hidden;
  color: ${COLORS.GRAY_DARK};
  width: 160px;
  height: 44px;
  border-radius: 6px;
  position: relative;
  cursor: pointer;
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 9px;
  background: ${COLORS.GRAY_LIGHT};
  border: 1px solid ${COLORS.GRAY};

  input {
    position: absolute;
    visibility: hidden;
  }

  svg {
    margin-right: 9px;
  }

  ${(props: ButtonProps) => props.isDisabled && `
    pointer-events: none;
    opacity: .3;
    cursor: not-allowed;
  `}
`;

export const TextButton = styled.p``;

export const Price = styled.span`
  display: block;
  font-size: 12px;
  text-align: center;
`;

export const IconCloseWrapper = styled.span`
  background: ${(props: Props) => props.color ? props.color : COLORS.GRAY_PLACEHOLDER};
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  display: flex;
  cursor: pointer;

  svg {
    margin: auto;
  }
`;

export const Loading = styled.span`
  right: 0;
  z-index: 10;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

export const ImagePreview = styled.img`
  width: auto;
  height: 100%;
  ${(props: ImageProps) => props.isDisplay ? `
    display: inline-block;
  `: `
    display: none;
  `}
`;

export const ErrorMessage = styled.span`
  color: ${COLORS.RED_ERROR};
`;

export const Info = styled.span`
  margin-top: 10px;
  font-family: ${FONTS.ROBOTO};
  font-size: 14px;
  color: ${COLORS.GRAY_DARK};
`;